import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import NIG from 'src/components/views/EscritosLexnet/components/shared/components/NIG/NIG'
import OrganoDestino from 'src/components/views/EscritosLexnet/components/shared/components/OrganoDestino/OrganoDestino'
import Procedimiento from 'src/components/views/EscritosLexnet/components/shared/components/Procedimiento/Procedimiento'

function Destino(): JSX.Element {
  const { t } = useTranslation()

  return (
    <FieldsetGroup legend={t('form.legend.destino')}>
      <OrganoDestino />
      <Procedimiento />
      <NIG />
    </FieldsetGroup>
  )
}

export default Destino
